import { get } from "./apiService";

export const fetchAccountType = async () => {
  return get({ path: 'AccountType' });
}